export default "__VITE_ASSET__d6d54a42__"